import { COOKIE_ID } from "../../constant";
import { cookies } from "../../cookies";

const selector = ".wp-block-steam-blocks-navigation-link.has-count";
const node = document.querySelector(selector);

if (node) {
	const span = document.createElement("span");
	span.classList.add("wp-block-steam-blocks-navigation-link__count");
	span.innerHTML = cookies.get(COOKIE_ID)?.length ?? 0;

	const inner = node.querySelector(".wp-block-steam-blocks-navigation__item");
	inner.appendChild(span);

	cookieStore.addEventListener("change", (event) => {
		span.innerHTML = cookies.get(COOKIE_ID).length;
	});
}
